import { Routes } from "@angular/router";

const scope: string = "feature/access-control-routes";

export const ACCESS_CONTROL_ROUTES: Routes = [
  {
    /* TODO: die sollte man vielleicht loswerden */
    path: "new",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Ausweiserstellung",
              token: "breadcrumb-label-id-creation",
              scope
            }
          }
        }
      }
    }
  },
  {
    path: "id-cards",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Ausweisübersicht",
              token: "breadcrumb-label-id-overview",
              scope
            }
          }
        }
      }
    },
    children: [
      {
        path: "new/type/sid",
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Neuer Baustellenausweis",
                  token: "breadcrumb-label-new-construction-site-id-card",
                  scope
                }
              }
            }
          }
        },
        children: [
          {
            path: "customers/:customerNumber/employees/:employeeNumber/id-card/:cardNumber",
            data: {
              context: {
                breadcrumb: {
                  apiPath: "api/customers/{customerNumber}/employees/{employeeNumber}"
                }
              }
            }
          }
        ]
      },
      {
        path: ":cardNumber/type/sid/customers/:customerNumber/employees/:employeeNumber",
        data: {
          context: {
            breadcrumb: {
              apiPath: "api/customers/{customerNumber}/employees/{employeeNumber}"
            }
          }
        }
      },
      {
        path: ":cardNumber/type/did/customers/:customerNumber/employees/:employeeNumber",
        data: {
          context: {
            breadcrumb: {
              apiPath: "api/access-control/projects/{projectNumber}/daily-identifications/{cardNumber}"
            }
          }
        }
      },
      {
        path: ":cardNumber/type/vid/customers/:customerNumber/employees/:employeeNumber",
        data: {
          context: {
            breadcrumb: {
              apiPath: "api/access-control/projects/{projectNumber}/visitor-identifications/{cardNumber}"
            }
          }
        }
      },
      {
        path: ":cardNumber/type/wcb/customers/:customerNumber/employees/:employeeNumber",
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "todo",
                  token: "breadcrumb-label-todo",
                  scope
                }
              }
            }
          }
        }
      }
    ]
  },
  {
    path: "minimum-wage/edit/:periode",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Mindestlohndokumente",
              token: "breadcrumb-label-minimum-wage-documents",
              scope
            }
          }
        }
      }
    }
  },
  {
    path: "minimum-wage/create/:periode",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Mindestlohndokumente erstellen",
              token: "breadcrumb-label-create-minimum-wage-documents",
              scope
            }
          }
        }
      }
    }
  },
  {
    path: "minimum-wage/overview",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Übersicht aller MLND",
              token: "breadcrumb-label-overview-all-mlnd",
              scope
            }
          }
        }
      }
    }
  },
  {
    path: "minimum-wage/settings",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Mindestlohn Einstellungen",
              token: "breadcrumb-label-minimum-wage-settings",
              scope
            }
          }
        }
      }
    }
  },
  {
    path: "reports/attendancelist",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Anwesenheitsliste erstellen",
              token: "breadcrumb-label-create-attendance-list",
              scope
            }
          }
        }
      }
    }
  },
  {
    path: "reports/idcardexportsettings",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Ausweisübersicht erstellen",
              token: "breadcrumb-label-create-id-overview",
              scope
            }
          }
        }
      }
    }
  },
  {
    /* TODO: Route anpassen */
    path: "reports/idcardexport",
    data: {
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Ausweisübersicht erstellen",
              token: "breadcrumb-label-create-id-overview",
              scope
            }
          }
        }
      }
    }
  }
];
